import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react'
import { X } from 'lucide-react'

interface Toast { message: string; undo?: () => void }
const ToastContext = createContext<(message: string, undo?: () => void) => void>(() => {})

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<Toast | null>(null)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const notify = useCallback((message: string, undo?: () => void) => {
    if (timer.current) clearTimeout(timer.current)
    setToast({ message, undo })
    timer.current = setTimeout(() => setToast(null), 5000)
  }, [])
  return (
    <ToastContext.Provider value={notify}>
      {children}
      {toast && (
        <div className="toast" role="status">
          <span>{toast.message}</span>
          {toast.undo && <button onClick={() => { toast.undo?.(); setToast(null) }}>Desfazer</button>}
          <button aria-label="Fechar" onClick={() => setToast(null)}><X size={15} /></button>
        </div>
      )}
    </ToastContext.Provider>
  )
}

export const useToast = () => useContext(ToastContext)
